<template>
  <svg
      :class="`icon-${name}`"
      :style="{
        fill,
        height: '1em',
        maxHeight: '1em',
        minHeight: '1em',
        width: 'auto',
        display: 'inline-block',
      }"
      :viewBox="viewbox"
      xmlns="http://www.w3.org/2000/svg">
    <slot/>
  </svg>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    viewbox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
    fill: {
      type: String,
      required: false,
      default: 'currentColor',
    },
  },
};
</script>
